/**
 * Suitsupply-style "How to measure" overlay (opens from size chart info icons)
 */
class SsMeasureGuide {
  constructor(container) {
    this.container = container;
    this.open = false;
    this.build();
    this.bind();
  }

  build() {
    this.el = document.createElement('div');
    this.el.className = 'ss-measure-guide';
    this.el.hidden = true;
    this.el.innerHTML = `
      <header class="ss-measure-guide__header">
        <button type="button" class="ss-measure-guide__icon-btn" data-back-measure aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <div class="ss-measure-guide__headings">
          <p class="ss-measure-guide__kicker">How to measure</p>
          <h3 class="ss-measure-guide__title" data-measure-title></h3>
        </div>
        <button type="button" class="ss-measure-guide__icon-btn" data-close-measure aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
      </header>
      <div class="ss-measure-guide__body" data-measure-body></div>
    `;
    this.container.appendChild(this.el);
    this.titleEl = this.el.querySelector('[data-measure-title]');
    this.kickerEl = this.el.querySelector('.ss-measure-guide__kicker');
    this.bodyEl = this.el.querySelector('[data-measure-body]');
  }

  stepImageHtml(step) {
    if (!step.image?.src) return '';
    const srcset = step.image.srcset
      ? ` srcset="${step.image.srcset}" sizes="(min-width: 769px) 312px, 100vw"`
      : '';
    return `<img class="ss-measure-guide__image" src="${step.image.src}" alt="" loading="lazy" decoding="async"${srcset}>`;
  }

  bind() {
    this.el.addEventListener('click', (e) => {
      if (e.target.closest('[data-back-measure]')) {
        e.preventDefault();
        this.hide();
      } else if (e.target.closest('[data-close-measure]')) {
        e.preventDefault();
        this.hide();
        this.container.dispatchEvent(new CustomEvent('ss-measure-guide:close-all', { bubbles: true }));
      }
    });
  }

  show(category, measureKey) {
    if (typeof SS_MEASURE_GUIDES === 'undefined') return;
    const guide = SS_MEASURE_GUIDES[category]?.[measureKey];
    if (!guide) return;

    this.titleEl.textContent = guide.title;
    if (this.kickerEl) this.kickerEl.textContent = guide.subtitle || 'How to measure';
    this.bodyEl.innerHTML = guide.steps
      .map(
        (step) => `
        <article class="ss-measure-guide__step">
          ${step.image ? `<div class="ss-measure-guide__illustration">${this.stepImageHtml(step)}</div>` : ''}
          ${step.heading ? `<h4 class="ss-measure-guide__step-title">${step.heading}</h4>` : ''}
          ${step.text ? `<p class="ss-measure-guide__step-text">${step.text}</p>` : ''}
        </article>`
      )
      .join('');

    this.el.hidden = false;
    this.open = true;
    this.container.classList.add('ss-measure-guide-open');
    this.container.dispatchEvent(
      new CustomEvent('ss-measure-guide:opened', { bubbles: true, detail: { category, measureKey } })
    );
  }

  hide() {
    if (!this.open) return;
    this.el.hidden = true;
    this.open = false;
    this.container.classList.remove('ss-measure-guide-open');
    this.container.dispatchEvent(new CustomEvent('ss-measure-guide:closed', { bubbles: true }));
  }

  isOpen() {
    return this.open;
  }
}

const measureGuideRoots = new WeakMap();

function getMeasureGuide(container) {
  if (!container) return null;
  if (!measureGuideRoots.has(container)) {
    measureGuideRoots.set(container, new SsMeasureGuide(container));
  }
  return measureGuideRoots.get(container);
}

function initSsMeasureGuides(scope = document) {
  scope.querySelectorAll('.ss-size-picker__modal--chart').forEach((modal) => {
    getMeasureGuide(modal);
  });
}

function openSsMeasureGuide({ category, measureKey, container }) {
  const root =
    container ||
    document.querySelector('.ss-size-picker__overlay--chart.active .ss-size-picker__modal--chart') ||
    document.querySelector('.ss-size-picker__modal--chart');
  const guide = getMeasureGuide(root);
  guide?.show(category, measureKey);
}

function closeSsMeasureGuide(container) {
  const root = container || document.querySelector('.ss-size-picker__modal--chart');
  getMeasureGuide(root)?.hide();
}

if (typeof window !== 'undefined') {
  window.initSsMeasureGuides = initSsMeasureGuides;
  window.openSsMeasureGuide = openSsMeasureGuide;
  window.closeSsMeasureGuide = closeSsMeasureGuide;
}
